<app-topbar></app-topbar>
<app-active-booking-badge *ngIf="!isTvScreen"></app-active-booking-badge>

<div class="planning-container">
  <div class="planning-overlay">
    <div class="row overlay-row">
      <div class="column small-1 large-1"></div>
      <div style="padding: 0" class="column small-10 large-10 column-overlay-content">
        <div class="col-10-split-activities" *ngFor="let a of [0,1,2,3,4,5,6]"
             [ngClass]="{'active': isSelected(dates[a])}"></div>
      </div>
      <div class="column small-1 large-1"></div>
    </div>
  </div>
  <div>
    <div class="row type-row" [ngClass]="{expanded: typeRowExpanded}">
      <div class="column small-1 large-1 col-group-label">
        <div class="type-left-content">{{(filterMode === 'by_task' ? 'LBL_ACTIVITY' : 'GROUP') | translate }} </div>
      </div>
      <div class="column small-10 large-10 type-content-column">
        <ng-scrollbar class="htz-scrollbar"
                      style="width: 100%;"
                      [pointerEventsDisabled]="false"
                      [track]="'horizontal'"
                      [visibility]="'hover'">
          <ng-container *ngIf="filterMode === 'by_task'; else default_filter_mode;">
            <div class="col-10-split-type filter-btn"
                 *ngFor="let task of taskList"
                 (click)="toggleTask(task)"
                 [ngClass]="{
                    active: isSelectedTask(task),
                    'light-contrast': task.color === 'light'
                  }">
              <div class="type-content-title group-inner-btn"
                   [ngStyle]="{
                    backgroundColor: isSelectedTask(task) ? task.color : '',
                    borderLeft: '4px solid ' + (task?.color || '#ffffff')
                    }">
                {{task.label}}
              </div>
            </div>
          </ng-container>
          <ng-template #default_filter_mode>
            <div class="col-10-split-type filter-btn"
                 *ngFor="let group of groupList"
                 (click)="toggleGroup(group)"
                 [ngClass]="{ active: isSelectedGroup(group), 'light-contrast': group.bestContrast === 'light' }">
              <div class="type-content-title group-inner-btn"
                   [ngStyle]="{
               backgroundColor: isSelectedGroup(group) ? group.color : '',
               borderLeft: '4px solid ' + (group?.color || '#FFFFFF')
               }">
                {{group.label}}
              </div>
            </div>
          </ng-template>
        </ng-scrollbar>
      </div>
      <div style="padding: 0;" class="column small-1 large-1 reset-groups-btn">
        <div class="type-right-content-container"
             (click)="typeRowExpanded = !typeRowExpanded"
             *ngIf="taskList?.length || groupList?.length">
          <img [src]="typeRowExpanded ?
          './assets/img/times-circle.svg'
          : './assets/img/chevron-down.svg'" class="type-right-content">
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row period-nd-coach-row">
      <div class="column small-1 large-1">
        <div class="period-left-content">{{'PERIOD' | translate}}</div>
      </div>
      <div class="column small-6 large-6 period-right-col">
        <ng-container *ngFor="let periodKey of periodList">
          <div class="period-tab"
               (click)="scrollInto(periodKey)"
               [ngClass]="{'active': currentPos === periodKey }">
            {{ periodLocale[periodKey] }}
          </div>
        </ng-container>
        <ng-container *ngIf="periodList.length <= 0">
          {{'NO_DATA_AVAILABLE' | translate}}
        </ng-container>
      </div>
      <div class="column small-4 large-4">
        <div class="coach-picker-block">
          <a href="javascript:void(0);"
             class="coach-picker"
             (click)="openCoachesPicker()">
            <div class="col-5-split-coach-bis">{{'COACH' | translate}}</div>
            <div class="coach-picker-lbl"
                 *ngIf="!selectedCoaches.length">{{'NO_COACH_SELECTED' | translate}}</div>
            <div class="coach-picker-lbl not-empty"
                 *ngIf="selectedCoaches.length">{{selectedCoachesStr}}</div>
          </a>
          <a href="javascript:void(0)"
             class="coach-reset-btn"
             [attr.disabled]="selectedCoaches.length <= 0"
             (click)="resetCoaches({fetch: true})"
             *ngIf="selectedCoaches?.length">
            <img src="./assets/img/times-circle.svg">
          </a>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row day-row">
      <div id="triangle" *ngIf="isFirstDayToday"></div>
      <div class="column small-1 large-1 ">
        <button class="chevron-btn chevron-left-container"
                [disabled]="currentWeekOffset === 0"
                (click)="week(-1)">
          <img src="./assets/img/chevron-circle-left.svg" alt="Semaine précedent" class="chevron-left">
        </button>
      </div>
      <div style="padding-right: 0; padding-left: 0;" class="column small-10 large-10 day-content-column">
        <ng-container *ngIf="dates?.length">
          <div class="col-10-split" *ngFor="let date of dates"
               [ngClass]="{'active': isSelected(date)}" (click)="toggleData(date)">
            <div class="txt-container">
              <div class="day">{{date.weekDay}}</div>
              <div class="month">{{date.dateStr}}</div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="column small-1 large-1">
        <button class="chevron-btn chevron-right-container"
                [disabled]="currentWeekOffset === 2"
                (click)="week(+1)" disabled>
          <img src="./assets/img/chevron-circle-right.svg" alt="Prochaine Semaine" class="chevron-right">
        </button>
      </div>
    </div>
  </div>
  <div class="filter-warn"
       (click)="resetAll()"
       *ngIf="selectedTasks?.length
       || selectedGroups?.length
       || selectedCoaches?.length">
      {{ 10820 | translate}} <img class="filter-warn-icon" src="assets/img/times-circle-white.svg">
  </div>
  <div class="activities-content" #planningContent>
    <div *ngIf="periodList.length === 0" style="display: flex; flex: 1; justify-content: center; align-items: center">
      {{'NO_DATA_AVAILABLE' | translate}}
    </div>
    <ng-container *ngIf="periodList.length >= 1">
      <ng-scrollbar class="htz-scrollbar"
                    style="width: 100%;"
                    [track]="'vertical'"
                    [visibility]="'hover'">
        <ng-container *ngFor="let periodItem of periodList">
          <ng-container *ngIf="periodItem.length">
            <div class="row activities-row-title"
                 [attr.data-section]="periodItem"
                 (click)="togglePanel($event, periodItem)">
              <div class="column small-12 large-12 activities-left-content-title">
                <span class="flex">{{ periodLocale[periodItem] }}</span>
                <span style="display: block; width: 20px; position: relative;"><img
                  [attr.src]="periodCollapse[periodItem] ? './assets/img/angle-right.svg' : './assets/img/angle-down.svg'"></span>
              </div>
            </div>
            <div class="panel-collapse" [class.collapsed]="periodCollapse[periodItem]">
              <ng-container *ngFor="let hour of hours[periodItem]">

                <div class="row activities-row" [attr.data-hour]="hour">
                  <div class="column small-1 large-1 activities-left-content">
                    <div class="activities-left-time-bloc">
                      <div class="activities-left-time">{{hour}}</div>
                    </div>
                  </div>
                  <div style="padding: 0;" class="column small-10 large-10 activities-content-column">
                    <div class="col-10-split-activities" *ngFor="let col of [0,1,2,3,4,5,6]">
                      <ng-container *ngIf="scheduler">
                        &nbsp;
                        <ng-container *ngIf="scheduler && scheduler[dates[col].fullDateStr]; else other_content">
                          <a class="content-activities-bloc"
                             *ngFor="let act of scheduler[dates[col].fullDateStr][hour]"
                             [ngStyle]="{
                                borderLeft: '4px solid ' + ((
                                filterMode === 'by_task' ?
                                    (taskDictionary && taskDictionary[act.idActivity]?.color):
                                     (groupDictionary && groupDictionary[act.idGroup]?.color)
                                ) || 'transparent')
                              }"
                             (click)="openActivity($event,act)">
                            <div class="content-activities-time">{{act.start | time}} ({{act.duration}}')</div>
                            <div class="content-activities-type">{{act.activity}}</div>
                            <div class="content-activities-place"> {{act.room}} - {{act.employee}}</div>
                          </a>
                        </ng-container>
                        <ng-template #other_content>&nbsp;</ng-template>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-scrollbar>
    </ng-container>
  </div>
</div>


<div
  id="tvPopup"
  *ngIf="tvPopup?.info"
  class="tv-popup"
  [clickOutsideEnabled]="!!tvPopup?.info"
  (clickOutside)="closeTvPopup()"
  [exclude]="'.content-activities-bloc'">
  <div class="border"></div>
  <button class="close-btn" (click)="closeTvPopup()">
    <img src="./assets/img/times-circle.svg" alt="Times circle" width="16">
  </button>
  <div>
    <div class="exercice-popup-img-container">
      <div class="exercice-popup-logo">
        <div class="inner">
          <img class="inner-img"
               [src]="tvPopup.info.task.photo | apiasset | defaultAsset:'DEFAULT_IMAGE_4_3' ">
        </div>
      </div>
      <div class="exercice-popup-img"
           [ngStyle]="{backgroundImage: 'url(' + (tvPopup.info.task.cover |apiasset | defaultAsset:'DEFAULT_IMAGE_16_9') + ')'}"></div>
    </div>
  </div>
  <div class="tv-popup-header">
    <h4>{{tvPopup.info.task.label}}</h4>
    <div class="flex"></div>
    <div class="time-col">
      <span>{{tvPopup.info.scheduledTask.start | date:'HH:mm' }} ({{tvPopup.info.scheduledTask.duration}}')</span>
      <span class="date">{{tvPopup.info.scheduledTask.start | date:'EEEE, dd/MM' }}</span>
    </div>
  </div>
  <div class="tv-popup-info">
    <div class="description">{{tvPopup.info.task.description || ''}}</div>
    <div class="coach">{{ 'COACH' | translate }} {{ tvPopup.info.scheduledTask.employee || '-'}} </div>
    <div class="room">{{ 'ROOM' | translate }}: {{ tvPopup.info.scheduledTask.room || '-'}}</div>
  </div>
</div>
<!--<div style="width: 200px; height: 100vh; position: absolute; left: 0; top: 0;">-->
<!--  -->
<!--</div>-->
